import React from 'react';
const Feedback = ({ handleRedirection }) => {
    return (
        <button className="Feedback pointer" onClick={handleRedirection}>
            <span className="FeedBckSet">
                <span className="feedBckDesc">Leave us feedback</span>
                <i className="fa-regular fa-comment-dots fa-flip-horizontal"></i>
            </span>
        </button>
    );
};
export default Feedback;
